<input [style]="{'text-align': element._get('horizontalTextAlignment')}" type="number" [readonly]="element._get('readOnly')" [max]="element._get('maxValue')" [min]="element._get('minValue') !== ''? element._get('minValue') : (element._get('allowNegative')? '':0)" [(ngModel)]="element._value">

